$(document).on("turbolinks:load", () => {
    if ($("#cloud_charts").length > 0) {
        $.ajax({
            type: "GET",
            url: "/charts/members_volunteers_scatter",
            success: function(response) {
            infos = createCloudChart("Members vs Volunteers", "Volunteers", "Members", response, "m_v_container")
            }
        });

        $.ajax({
            type: "GET",
            url: "/charts/service_request_events_participation_scatter",
            success: function(response) {
            infos = createCloudChart("Service Requests vs Events Attendance", "Events Attendance", "Service Requests", response, "sr_ev_container")
            }
        });

        $.ajax({
            type: "GET",
            url: "/charts/irl_online_scatter",
            success: function(response) {
            infos = createCloudChart("Irl Score vs Online Score",  "Online Score", "Irl Score", response, "irl_online_container")
            }
        });
    }
})

function createCloudChart(title, x_title, y_title, data, container) {
    Highcharts.chart(container, {
        chart: {
            type: 'scatter',
            zoomType: 'xy'
        },
        title: {
            text: title
        },
        xAxis: {
            title: {
                enabled: true,
                text: x_title
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true
        },
        yAxis: {
            title: {
                text: y_title
            }
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.x} ' + x_title + ', {point.y} ' + y_title
                }
            }
        },
        series: data
    });
}